module.exports = __webpack_public_path__ + "static/who_we_work_with-8335cac5312cddca457980c6f2718afc.png";